import { useQuery } from "@tanstack/react-query";
import { getAllMembershipsApi } from "../membership.services";
import { RAMSALAB_ORG } from "../../constants/constants";
import { useSelector } from "react-redux";

export const MEMBERSHIPS_KEY = "memberships";

export const useGetAllMembership = ({ queryConfig }) => {
  const { queryKey, apiParams, ...restConfig } = queryConfig;
  const OrgSlug = localStorage.getItem(RAMSALAB_ORG);
  apiParams.org = OrgSlug;

  return useQuery({
    queryKey: [MEMBERSHIPS_KEY,  ...queryKey],
    queryFn: () =>
      getAllMembershipsApi({
        ...apiParams,
      }),
    refetchOnWindowFocus: false,
    ...restConfig,
  });
};

/**
 * Hook to fetch the current user's membership in the active organization
 * Useful for determining if a user has org permissions (owner, maintainer, supervisor)
 */
export const useGetCurrentUserMembership = () => {
  const { ramsalabUserData } = useSelector((state) => state.loginReducer);
  const OrgSlug = localStorage.getItem(RAMSALAB_ORG);
  const currentUsername = ramsalabUserData?.username;

  const query = useQuery({
    queryKey: [MEMBERSHIPS_KEY, "current-user", OrgSlug, currentUsername],
    queryFn: () =>
      getAllMembershipsApi({
        org: OrgSlug,
        page_size: 100,
      }),
    refetchOnWindowFocus: false,
    // Only enable the query if we have an org slug and username
    enabled: !!OrgSlug && !!currentUsername,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  // Find the current user's membership from the results
  const currentUserMembership = query.data?.results?.find(
    (membership) => membership.user?.username === currentUsername
  );

  return {
    ...query,
    data: currentUserMembership,
    isOrgStaff: currentUserMembership?.role && 
                ["owner", "maintainer", "supervisor"].includes(currentUserMembership.role),
    userRole: currentUserMembership?.role || null,
  };
};
